import React from 'react';

const ChatPage: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">
        AI Chat
      </h1>
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
        <p className="text-gray-600 dark:text-gray-400">
          Chat interface coming soon...
        </p>
      </div>
    </div>
  );
};

export default ChatPage;
